
import React from 'react';

interface RoleBadgeProps {
  userRole?: { role?: string };
  loading?: boolean;
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ userRole, loading }) => {
  if (!userRole || loading) return null;
  
  let color = 'bg-gray-100 text-gray-800';
  
  if (userRole.role === 'super') {
    color = 'bg-purple-100 text-purple-800';
  } else if (userRole.role === 'admin') {
    color = 'bg-blue-100 text-blue-800';
  } else if (userRole.role === 'member') {
    color = 'bg-green-100 text-green-800';
  } else if (userRole.role === 'viewer') {
    color = 'bg-amber-100 text-amber-800';
  }
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${color}`}>
      {userRole.role === 'super' && 'מנהל-על'}
      {userRole.role === 'admin' && 'מנהל'}
      {userRole.role === 'member' && 'משתמש'}
      {userRole.role === 'viewer' && 'צופה'}
    </span>
  );
};

export default RoleBadge;
